import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import LoadingPanel from "../common/LoadingPanel";

import {
  FaEdit,
  FaTrash,
  FaSave,
  FaTimes,
  FaList,
  FaFileExcel,
} from "react-icons/fa"; // Import the desired icons
import { useAuth } from "../../auth/AuthContext";
import UtilMethods from "../../util/UtilMethods";
import {
  fetchUsers,
  updateUser,
  deleteUser,
} from "../../services/AdminServices";
import * as XLSX from "xlsx"; // Import XLSX for Excel export
import adminMenu from "../../source/menuAdmin.json";
import userMenu from "../../source/menuUser.json";
import guestMenu from "../../locales/en/menuGuest.json";
const ListUserPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");

  const handleShowModal = (address) => {
    setSelectedAddress(address);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);
  const menuData = {
    items: [...adminMenu.items, ...userMenu.items, ...guestMenu.items],
  };

  const menuSubItems = menuData.items.filter(item => item.subItems).map(item => item.subItems).flat();
  const { user, userType } = useAuth();
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [editingUserId, setEditingUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("");

  const loggedInUserId = user?.user?.id || user?.id;
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(15);

  useEffect(() => {
    const loadUsers = async () => {
      setLoading(true);
      try {
        const usersData = await fetchUsers();
        setUsers(usersData);
        setFilteredUsers(usersData);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, []);

  const handleExportToXLS = () => {
    const data = filteredUsers.map((user) => ({
      ID: user.userID,
      FirstName: user.firstName,
      LastName: user.lastName,
      Email: user.email,
      Gender: user.gender,
      Age: user.age,
      Phone: user.phone,
      Address: user.address,
      City: user.city,
      State: user.state,
      Zip: user.zip,
      Country: user.country,
      UserType: user.userType,
      remarks: user.remarks,
      UserGroup: user.userGroup,
      Active: user.isActive ? "Yes" : "No",
      UpdatedAt: user.updatedAt,
      CreatedAt: user.createdAt,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
    XLSX.writeFile(workbook, "users_data.xlsx");
  };

  const handleEditClick = (userID) => {
    setEditingUserId(userID);
  };

  const handleCancelEdit = () => {
    setEditingUserId(null);
  };

  const handleUpdateUser = async (updatedUser) => {
    try {
      if (!updatedUser.password.startsWith("$2b$")) {
      const passwordCheck = UtilMethods.validatePassword(updatedUser.password);
        if(passwordCheck && passwordCheck !== "Y") {
          alert(passwordCheck);
          return;
        }
      }
      await updateUser(updatedUser);
      setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user.userID === updatedUser.userID ? updatedUser : user
        )
      );
      setFilteredUsers((prevUsers) =>
        prevUsers.map((user) =>
          user.userID === updatedUser.userID ? updatedUser : user
        )
      );
      setEditingUserId(null);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleDeleteUser = async (userID) => {
    const userToDelete = users.find((user) => user.userID === userID);
    const userName = userToDelete
      ? `${userToDelete.firstName} ${userToDelete.lastName}`
      : "Unknown User";
    const userConfirmed = window.confirm(
      `Are you sure you want to delete the user with ID: ${userID} - ${userName}?`
    );

    if (userConfirmed) {
      if (userID === loggedInUserId) {
        alert("You cannot delete your own account.");
        return;
      }
      try {
        await deleteUser(userID);
        setUsers((prevUsers) =>
          prevUsers.filter((user) => user.userID !== userID)
        );
        setFilteredUsers((prevUsers) =>
          prevUsers.filter((user) => user.userID !== userID)
        );
      } catch (error) {
        alert("Error deleting user. Please try again.");
      }
    }
  };

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setFilter(value);
    const filtered = value
      ? users.filter(
          (user) =>
            user.firstName.toLowerCase().includes(value.toLowerCase()) ||
            user.email.toLowerCase().includes(value.toLowerCase())
        )
      : users;
    setFilteredUsers(filtered);
    setCurrentPage(1);
  };
  const handleInputChange = (e, userID) => {
    const { name, type, checked, value } = e.target;

    setFilteredUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.userID === userID
          ? { ...user, [name]: type === "checkbox" ? checked : value }
          : user
      )
    );
  };

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>
      {/* Title Section */}
      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">User Management</h1>
          </div>
        </div>
      </div>

      <div className="container-fluid mt-5 mb-5">
        <div className="filter-panel d-flex align-items-left">
          <div className="col-md-4 me-2">
            <input
              type="text"
              placeholder="Filter by name or email"
              value={filter}
              onChange={handleFilterChange}
              className="form-control me-2"
              // Limit the input width to keep everything in one row
            />
          </div>
          <button
            className="btn btn-primary btn-sm me-2"
            onClick={() => {
              setFilter("");
              setFilteredUsers(users);
              setCurrentPage(1);
            }}
          >
            <FaList style={{ marginRight: "0.5rem" }} />
            List
          </button>

          <button
            onClick={handleExportToXLS}
            className="btn btn-success btn-sm"
          >
            <FaFileExcel style={{ marginRight: "0.5rem" }} />
            Excel
          </button>
        </div>
        {error ? (
          <div className="alert alert-danger" role="alert">
            <strong>Error:</strong> {error}
          </div>
        ) : loading ? (
          <LoadingPanel />
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered mt-4">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Actions</th>
                  <th>Email</th>
                  <th>Gender</th>
                  <th>Age</th>
                  <th>Phone</th>
                  <th>Address</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Zip</th>
                  <th>Country</th>
                  <th>User Type</th>
                  <th>User Group</th>
                  <th>Remarks</th>
                  <th>Default Page</th>
                  <th>Password</th>
                  <th>Active</th>
                  <th>Updated At</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.map((user) => (
                  <tr key={user.userID}>
                    {editingUserId === user.userID ? (
                      <>
                        <td>
                          <td>{user.userID}</td>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="firstName"
                            value={user.firstName}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="lastName"
                            value={user.lastName}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td className="d-flex gap-2">
                          {" "}
                          {/* Added d-flex and gap-2 for spacing */}
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleUpdateUser(user)}
                            style={{
                              display: "flex",
                              alignItems: "right",
                              justifyContent: "right",
                            }}
                          >
                            <FaSave style={{ fontSize: "0.8rem" }} />
                          </button>
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={handleCancelEdit}
                            style={{
                              display: "flex",
                              alignItems: "right",
                              justifyContent: "right",
                            }}
                          >
                            <FaTimes style={{ fontSize: "0.8rem" }} />
                          </button>
                        </td>
                        <td>
                          <input
                            type="email"
                            name="email"
                            value={user.email}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="gender"
                            value={user.gender}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            name="age"
                            value={user.age}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="phone"
                            value={user.phone}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="address"
                            value={user.address}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="city"
                            value={user.city}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="state"
                            value={user.state}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="zip"
                            value={user.zip}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="country"
                            value={user.country}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            name="userType"
                            value={user.userType}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            name="userGroup"
                            value={user.userGroup}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="remarks"
                            value={user.remarks}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <select
                            name="defaultPage"
                            value={user.defaultPage}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          >
                              {menuSubItems.map((item, index) => (
                                <option key={index} value={item.link}>
                                  {item.name}
                                </option>
                              ))}
                          </select>
                        </td>
                        <td>
                          <input
                            type="password"
                            name="password"
                            value={user.password}
                            onChange={(e) => handleInputChange(e, user.userID)}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="isActive"
                              checked={user.isActive}
                              onChange={(e) =>
                                handleInputChange(e, user.userID)
                              }
                            />
                          </div>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="updatedAt"
                            value={user.updatedAt}
                            className="form-control"
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="createdAt"
                            value={user.createdAt}
                            className="form-control"
                            readOnly
                          />
                        </td>
                       
                      </>
                    ) : (
                      <>
                        <td>{user.userID}</td>
                        <td>{user.firstName}</td>
                        <td>{user.lastName}</td>
                        <td>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>Edit: Modify this record</Tooltip>
                            }
                          >
                            <button
                              className="btn btn-warning btn-sm"
                              onClick={() => handleEditClick(user.userID)}
                            >
                              {editingUserId === user.userID ? (
                                <FaSave
                                  style={{
                                    marginRight: "0",
                                    fontSize: "0.8rem",
                                  }}
                                /> // Save icon
                              ) : (
                                <FaEdit
                                  style={{
                                    marginRight: "0",
                                    fontSize: "0.8rem",
                                  }}
                                /> // Edit icon
                              )}
                            </button>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                Delete : This action cannot be undone. Please be
                                careful!
                              </Tooltip>
                            }
                          >
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDeleteUser(user.userID)}
                            >
                              <FaTrash
                                style={{
                                  marginRight: "0",
                                  fontSize: "0.8rem",
                                }}
                              />
                            </button>
                          </OverlayTrigger>
                        </td>
                        <td>{user.email}</td>
                        <td>{user.gender}</td>
                        <td>{user.age}</td>
                        <td>{user.phone}</td>
                        <td>{user.address}</td>
                        <td>{user.city}</td>
                        <td>{user.state}</td>
                        <td>{user.zip}</td>
                        <td>{user.country}</td>
                        <td>{user.userType}</td>
                        <td>{user.userGroup}</td>
                        <td>{user.remarks}</td>
                        <td>{user.defaultPage}</td>
                        <td>********</td>
                        <td>{user.isActive ? "Yes" : "No"}</td>
                        <td>{UtilMethods.formatDateTime(user.updatedAt)}</td>
                        <td>{UtilMethods.formatDateTime(user.createdAt)}</td>

                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="pagination">
              {Array.from({ length: totalPages }, (_, index) => index + 1).map(
                (pageNumber) => (
                  <button
                    key={pageNumber}
                    onClick={() => paginate(pageNumber)}
                    className={`btn btn-sm ${
                      pageNumber === currentPage ? "btn-primary" : "btn-light"
                    }`}
                  >
                    {pageNumber}
                  </button>
                )
              )}
            </div>
          </div>
        )}
      </div>

      <FooterPanel />
    </React.Fragment>
  );
};

export default ListUserPage;
